module.exports = __webpack_public_path__ + "static/img/COVER-10.9733f6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/COVER-10.png
// module id = dGpH
// module chunks = 31